<template>
  <div class="page-wrap">
    <div class="filter">
      <div class="header-title">新增ROI预测表</div>
      <div class="filter-input">
        <el-date-picker
          v-model="filterData.date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-select v-model="filterData.pkg" filterable placeholder="选择产品" class="select">
          <el-option
            v-for="item in productList"
            :key="item.pkg"
            :label="`${item.appName}(${item.afid})`"
            :value="item.pkg"
          >
          </el-option>
        </el-select>
        <el-select v-model="filterData.dimension" filterable placeholder="选择维度" class="select">
          <el-option
            v-for="item in dimensionList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select v-model="filterData.platType" filterable placeholder="选择渠道" class="select">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button type="primary" class="btn" @click="handleBtnSearch">查询</el-button>
        <el-button @click="handleRest" class="btn">重置</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :border="false"
        :data="tableList"
        ref="table"
        style="width: 100%"
        :max-height="tableHeight"
        :header-cell-style="headerCellStyle"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
        :key="tableKey"
        @sort-change="tableSortChange"
      >
        <el-table-column label="维度" fixed align="left" min-width="150">
          <el-table-column
            :prop="dynamicColumnProps"
            :label="dynamicColumnLabel"
            min-width="150"
            align="left"
            :sortable="dynamicSortable"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="消耗" fixed align="center" min-width="240">
          <el-table-column
            v-for="item in consumeColumn"
            :prop="item.id"
            :label="item.label"
            :key="item.id"
            width="120"
            align="left"
            sortable="custom"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="基础数据" align="center">
          <el-table-column
            v-for="item in basicColumn"
            :prop="item.id"
            :label="item.label"
            :key="item.id"
            width="100"
            align="left"
            sortable="custom"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="7日预测结果" align="center">
          <el-table-column
            v-for="item in sevenPredictColumn"
            :prop="item.id"
            :label="item.label"
            :key="item.id"
            width="100"
            align="left"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="30日预测结果" align="center">
          <el-table-column
            v-for="item in thirtyPredictColumn"
            :prop="item.id"
            :label="item.label"
            :key="item.id"
            width="100"
            align="lef"
          >
          </el-table-column>
        </el-table-column>
      </el-table>
      <self-pagination
        class="footer-page"
        :total="pageData.total"
        :pageSize="pageData.pageSize"
        :currentPage="pageData.page"
        ref="tabelPagination"
        @getCurrentPage="changePage"
        @handleSizeChange="handleSizeChange"
      ></self-pagination>
    </div>
  </div>
</template>

<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import { getRoiPredictTable, getRoiProductList } from "@/api/api";
import moment from "moment";
import {
  dimensionList,
  dimensionReflect,
  basicColumn,
  sevenPredictColumn,
  thirtyPredictColumn,
  consumeColumn,
} from "./config";
export default {
  components: {},

  data() {
    return {
      dimensionList,
      basicColumn,
      sevenPredictColumn,
      thirtyPredictColumn,
      consumeColumn,
      dynamicColumnProps: "",
      dynamicColumnLabel: "",
      dynamicSortable: false,
      tableKey: Math.random(),
      tableList: [],
      filterData: {
        date: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
        dimension: 1,
        platType: 24,
        // 产品列表
        pkg: "",
      },
      productList: [],
      channelList: [
        {
          label: "华为",
          id: 24,
        },
      ],
      pageData: {
        total: 0,
        pageSize: 10,
        page: 1,
      },
      tableHeight: window.innerHeight - 350,
      loading: false,
      column: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
      // 需要排序的字段
      sortFiled: "",
      // 排序方式 1降序 2升序
      sortValue: "",
    };
  },
  mounted() {
    getRoiProductList().then((res) => {
      this.productList = res.data;
      this.filterData.pkg = res.data.length > 0 ? res.data[0].pkg : "";
      this.handleSearch();
    });
  },
  methods: {
    tableSortChange({ prop, order }) {
      if (order) {
        this.sortFiled = prop;
        this.sortValue = order === "ascending" ? 2 : 1;
      } else {
        this.sortFiled = "";
        this.sortValue = "";
      }

      this.handleSearch();
    },
    handleRest() {
      this.filterData = {
        date: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
        dimension: 1,
        platType: 24,
        // 产品列表
        pkg: "com.urack.hgaxc.huawei",
      };

      this.changePage(1);
    },
    handleBtnSearch() {
      this.sortFiled = "";
      this.sortValue = "";
      this.tableKey = Math.random();
      this.changePage(1);
    },
    handleSearch() {
      const params = {
        ...this.filterData,
        ...this.pageData,
        startTime: moment(this.filterData.date[0]).format("YYYY-MM-DD"),
        endTime: moment(this.filterData.date[1]).format("YYYY-MM-DD"),
        // 需要排序的字段
        sortFiled: this.sortFiled,
        // 排序方式 1降序 2升序
        sortValue: this.sortValue,
      };
      this.loading = true;
      getRoiPredictTable(params).then((res) => {
        this.dynamicColumnProps = dimensionReflect.get(this.filterData.dimension).props;
        this.dynamicColumnLabel = dimensionReflect.get(this.filterData.dimension).label;
        if (this.filterData.dimension === 1) {
          this.dynamicSortable = "custom";
        } else {
          this.dynamicSortable = false;
        }
        if (res.code === "0000") {
          if (res.data.totalPredictionInfo) {
            // 处理合计行
            const totalData = {
              ...res.data.totalPredictionInfo,
              cost: `¥ ${res.data.totalPredictionInfo.cost}`,
              advertiserId: "合计",
              campaignId: "合计",
              stateTime: "合计",
            };
            this.tableList = [
              totalData,
              ...res.data.predictionInfoList.map((i) => {
                return {
                  ...i,
                  advertiserId: `${i.advertiserName}(${i.advertiserId})`,
                  campaignId: `${i.campaignName}(${i.campaignId})`,
                  cost: `¥ ${i.cost}`,
                };
              }),
            ];
          } else {
            this.tableList = [
              {
                advertiserId: "合计",
                campaignId: "合计",
                stateTime: "合计",
              },
              ...res.data.predictionInfoList.map((i) => {
                return {
                  ...i,
                  advertiserId: `${i.advertiserName}(${i.advertiserId})`,
                  campaignId: `${i.campaignName}(${i.campaignId})`,
                  cost: `¥ ${i.cost}`,
                };
              }),
            ];
          }
          this.pageData.total = res.data.totalCount;
        }

        this.loading = false;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.handleSearch();
    },
    handleSizeChange(size) {
      this.pageData.pageSize = size;
      this.pageData.page = 1;
      this.handleSearch();
    },
    headerCellStyle({ rowIndex, columnIndex }) {
      if (rowIndex === 1 && (columnIndex === 9 || columnIndex === 14)) {
        return {
          color: "red",
        };
      }

      return {};
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .filter {
    padding: 20px 24px 20px 24px;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    background: white;
    box-shadow: 0px 2px 12px #0000001f;
    .header-title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 18px;
    }
    .filter-input {
      display: flex;
      flex-wrap: wrap;
      margin-top: 25px;
      > * {
        margin-right: 15px;
      }
      .btn {
        width: 100px;
      }
      .select {
        width: 270px;
      }
    }
  }
  .table {
    box-sizing: border-box;
    margin-right: 16px;
    padding: 24px;
    margin-top: 16px;
    margin-bottom: 16px;
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    box-shadow: 0px 2px 12px #0000001f;
    flex-grow: 1;
    overflow: hidden;
  }
}
</style>
